export { default as ListView } from 'projects/components/ProjectsListView';
export { default as FormView } from 'projects/components/ProjectFormView';



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/index.js